import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CompanyTierSettingService } from '../services/company-tier-setting.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerCrmEnabledGuard {
  private authService = inject(AuthService);
  private companyTierSettingService = inject(CompanyTierSettingService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let isCustomerCrmEnabled = false;
    try {
      const tierSettings = await this.companyTierSettingService.getCompanyTier(this.authService.user.companyId);
      isCustomerCrmEnabled = tierSettings?.customerCrmEnabled ?? false;
    } catch (error) {
      console.error(error);
    }
    if (isCustomerCrmEnabled) {
      return true;
    }
    return this.router.navigate(['/orders']);
  }
}
